<script setup lang="ts">
const props = defineProps<{ starters: string[] }>();
defineEmits(["select"]);

const presentStarters = computed(() => {
  return props.starters.filter((str) => str.length > 0);
});
</script>
<template>
  <div class="conversation-starter">
    <button
      v-for="str in presentStarters"
      :key="str"
      type="button"
      class="btn list-item"
      @click="$emit('select', str)"
    >
      <div class="list-item__text">
        {{ str }}
      </div>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.conversation-starter {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: $spacer-75;
  padding: $spacer-3;

  @include media-breakpoint-down(md) {
    grid-template-columns: 1fr;
  }
}

.list-item {
  display: flex;
  text-align: left;
  gap: $spacer-1;
  padding: $spacer-75 $spacer-3;
  border-radius: $border-radius-lg;
  border: 1px solid $border-color;
  color: $body-color;
  text-decoration: none;
  font-size: $font-size-sm;

  &__text {
    display: -webkit-box;
    overflow: hidden;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    @include media-breakpoint-down(md) {
      line-clamp: 1;
      -webkit-line-clamp: 1;
    }
  }

  &:hover {
    background-color: $hover-color;
  }
}
</style>
